import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { volatilityChart } from 'app/functions/functions';
import moment from 'moment';
import { TimeSeries } from 'app/interfaces/timeseries';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-intraday-chart',
  templateUrl: './intraday-chart.component.html',
  styleUrls: ['./intraday-chart.component.scss']
})
export class IntradayChartComponent implements OnInit {
  public lastEventDate = null;
  private _unsubscribeAll: Subject<any>;
  @Input() data: Observable<any> = null;
  @Input() type: string;
  public volatilityChartOpt: BehaviorSubject<any> = new BehaviorSubject(null);
  constructor() {
    this._unsubscribeAll = new Subject();
  }
  ngOnInit(): void {
    this.getTickerTodayStatus();
  }

  ngOnDestroy() {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  getTickerTodayStatus() {
    this.data.pipe(takeUntil(this._unsubscribeAll)).subscribe((result: any) => {
      if (result) {
        let volume = [];
        let price = [];
        let time_series = [];
        this.lastEventDate = result.recordedOn || '';
        if (this.type === 'stock') {
          result.timeSeries = result.timeSeries.reverse();
        }
        result.timeSeries.map((element: TimeSeries) => {
          let time = moment.utc(this.type === 'stock' ? element.date : element.timestamp).format('h:mm a');
          // let time = timezone.tz(moment.utc(element.timestamp), 'America/Chicago').format('hh:mm a');
          if (time_series.indexOf(time) < 0) {
            volume.push(Number(element.volume.toFixed(2)));
            price.push(Number(element.price.toFixed(2)));
            time_series.push(time);
          }
        });
        this.volatilityChartOpt.next(volatilityChart(time_series, price, volume, this.type))
      } else {
        this.volatilityChartOpt.next(null);
      }
    });
  }

}
